module.exports = __webpack_public_path__ + "img/icon-adjustment.a54ab21e.svg";